<div class="activate-password">
  <img
    src="assets/activate-password.png"
    class="active-password-image"
    alt="about digipay"
  />
  <span class="text-onback-medium st-4 mb-tiny">تنظیم رمز عبور</span>
  <span class="text-onback-low b-2 text-center">
    با تنظیم رمزعبور، می‌توانید به انتخاب خود برای ورود به دیجی‌پی و یا پرداخت با کیف‌پول، از آن استفاده کنید!
  </span>
  <div class="px-minus mt-medium w-100">
    <ngx-button
      (click)="handleActivation()"
      [style]="'tinted-on-elevated'"
      [size]="'medium'"
      [fullWidth]="true"
    >
      فعال سازی و تنظیم رمز عبور
    </ngx-button>
  </div>
</div>
